<template>
  <transition name="modal-fade">
    <div v-if="show" class="fixed inset-0 z-[9999] flex items-center justify-center p-4">
      <!-- 背景遮罩 -->
      <div class="absolute inset-0 bg-black bg-opacity-50 transition-opacity" @click="handleCancel"></div>
      
      <!-- 弹框内容 -->
      <div class="relative bg-white rounded-2xl shadow-2xl max-w-md w-full animate-scale-in transform">
        <!-- 图标 -->
        <div class="pt-8 pb-4 text-center">
          <div class="mx-auto w-16 h-16 rounded-full bg-orange-100 flex items-center justify-center">
            <i class="fas fa-exclamation-triangle text-orange-500 text-3xl"></i>
          </div>
        </div>
        
        <!-- 标题和内容 -->
        <div class="px-6 pb-6 text-center">
          <h3 class="text-xl font-semibold text-gray-900 mb-2">
            {{ title }}
          </h3>
          <p class="text-gray-600 text-sm">
            {{ message }}
          </p>
        </div>
        
        <!-- 按钮 -->
        <div class="flex gap-3 px-6 pb-6">
          <button 
            @click="handleCancel"
            class="flex-1 px-4 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-all font-medium"
          >
            {{ cancelText }}
          </button>
          <button 
            @click="handleConfirm"
            class="flex-1 px-4 py-2.5 bg-primary text-white rounded-lg hover:bg-primary/90 transition-all font-medium shadow-sm"
          >
            {{ confirmText }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ConfirmModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '确认操作'
    },
    message: {
      type: String,
      default: '确定要执行此操作吗？'
    },
    confirmText: {
      type: String,
      default: '确定'
    },
    cancelText: {
      type: String,
      default: '取消'
    }
  },
  data() {
    return {
      modalElement: null
    }
  },
  watch: {
    show(newVal) {
      if (newVal) {
        // 弹框打开时，阻止背景滚动
        document.body.style.overflow = 'hidden'
        // 将弹框移动到body下
        this.$nextTick(() => {
          if (this.$el && this.$el.parentNode) {
            document.body.appendChild(this.$el)
          }
        })
      } else {
        // 弹框关闭时，恢复滚动
        document.body.style.overflow = ''
      }
    }
  },
  mounted() {
    // 组件挂载后，将元素移动到body下
    if (this.$el && this.$el.parentNode) {
      this.modalElement = this.$el
      document.body.appendChild(this.$el)
    }
  },
  beforeDestroy() {
    // 组件销毁时，确保恢复滚动和移除元素
    document.body.style.overflow = ''
    if (this.$el && this.$el.parentNode === document.body) {
      document.body.removeChild(this.$el)
    }
  },
  methods: {
    handleConfirm() {
      this.$emit('confirm')
      this.$emit('update:show', false)
    },
    handleCancel() {
      this.$emit('cancel')
      this.$emit('update:show', false)
    }
  }
}
</script>

<style scoped>
/* 模态框淡入淡出动画 */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

/* 弹框缩放动画 */
@keyframes scale-in {
  0% {
    opacity: 0;
    transform: scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.animate-scale-in {
  animation: scale-in 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
</style>

